/* ================================================================
   FIORVITA v7b — JavaScript completo
   ================================================================ */
'use strict';

const FV = {

  /* INIT */
  init() {
    this.initHeader();
    this.initMobileNav();
    this.initCart();
    this.initReveal();
    this.initShopFilters();
    this.initNewsletterForms();
    this.initPopup();
    this.initPredictiveSearch();
    this.syncCart();
  },

  /* HEADER SCROLL */
  initHeader() {
    const h = document.querySelector('.header');
    if (!h) return;
    const onScroll = () => h.classList.toggle('scrolled', window.scrollY > 15);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  },

  /* MOBILE NAV */
  initMobileNav() {
    const toggle = document.querySelector('.header__mobile-toggle');
    const nav    = document.querySelector('.mobile-nav');
    const close  = document.querySelector('.mobile-nav__close');
    if (!toggle || !nav) return;
    const open = () => { nav.classList.add('open'); document.body.style.overflow = 'hidden'; };
    const shut = () => { nav.classList.remove('open'); document.body.style.overflow = ''; };
    toggle.addEventListener('click', open);
    close?.addEventListener('click', shut);
  },

  /* CARRITO REAL SHOPIFY */
  initCart() {
    document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', () => this.openCart()));
    document.querySelector('.cart-drawer__close')?.addEventListener('click', () => this.closeCart());
    document.querySelector('.cart-drawer__overlay')?.addEventListener('click', () => this.closeCart());
    document.getElementById('cart-clear')?.addEventListener('click', (e) => this.clearCart(e.currentTarget));

    // Delegación única: botones de producto (data-add-to-cart) y de pack (data-add-pack)
    document.addEventListener('click', (e) => {
      const packBtn = e.target.closest('[data-add-pack]');
      if (packBtn) {
        e.preventDefault();
        const ids = (packBtn.dataset.addPack || '').split(',').filter(Boolean);
        if (ids.length) this.addPack(ids, packBtn);
        return;
      }
      // Selector de cantidad en las tarjetas de producto
      const qtyBtn = e.target.closest('[data-qty-dir]');
      if (qtyBtn) {
        e.preventDefault();
        const wrap = qtyBtn.closest('.pc__qty');
        const input = wrap && wrap.querySelector('.pc__qty-input');
        if (input) {
          const max = parseInt(input.max) || 99;
          const next = (parseInt(input.value) || 1) + parseInt(qtyBtn.dataset.qtyDir);
          if (next > max) this.toast('Solo quedan ' + max + ' unidades disponibles');
          input.value = Math.max(1, Math.min(max, next));
        }
        return;
      }

      const btn = e.target.closest('[data-add-to-cart]');
      if (btn) {
        e.preventDefault();
        const variantId = btn.dataset.variantId || btn.dataset.addToCart;
        // Si la tarjeta tiene selector de cantidad, se respeta
        const card = btn.closest('.pc');
        const qtyInput = card && card.querySelector('.pc__qty-input');
        const qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
        if (variantId) this.addToCart(variantId, qty, btn);
      }
    });
  },

  openCart() {
    const d = document.getElementById('cart-drawer');
    if (!d) return;
    d.classList.add('open');
    document.body.style.overflow = 'hidden';
    d.setAttribute('aria-hidden', 'false');
    this.syncCart();
  },

  closeCart() {
    const d = document.getElementById('cart-drawer');
    if (!d) return;
    d.classList.remove('open');
    document.body.style.overflow = '';
    d.setAttribute('aria-hidden', 'true');
  },

  fmt(n) {
    return '$' + Math.round(n).toLocaleString('es-CL');
  },

  async fetchCart() {
    try {
      const res = await fetch('/cart.js');
      return await res.json();
    } catch(e) { return null; }
  },

  /* Punto de entrada único para agregar al carrito (botón opcional para feedback visual) */
  async addToCart(variantId, qty, btn) {
    qty = qty || 1;
    if (btn) btn.classList.add('loading');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
      });
      if (res.ok) {
        await this.syncCart();
        if (btn) {
          btn.classList.remove('loading');
          btn.classList.add('added');
          setTimeout(() => btn.classList.remove('added'), 2000);
        }
        this.openCart();
      } else {
        const err = await res.json().catch(() => ({}));
        console.error('Cart add error:', err.description || res.status);
        this.toast(err.description || 'No pudimos agregarlo: revisa el stock disponible.');
        if (btn) btn.classList.remove('loading');
      }
    } catch(e) {
      console.error('addToCart error:', e);
      if (btn) btn.classList.remove('loading');
    }
  },

  /* BÚSQUEDA FLEXIBLE — ignora tildes y tolera errores de tipeo */
  norm(s) {
    return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  },

  // Distancia de edición (Damerau-Levenshtein OSA): trasposiciones cuentan 1
  editDist(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev2 = null, prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      var rowMin = i;
      for (j = 1; j <= b.length; j++) {
        var cost = a[i-1] === b[j-1] ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j-1] + 1, prev[j-1] + cost);
        if (i > 1 && j > 1 && a[i-1] === b[j-2] && a[i-2] === b[j-1]) {
          v = Math.min(v, prev2[j-2] + 1);
        }
        cur[j] = v;
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[b.length];
  },

  // ¿El texto contiene (aprox.) todas las palabras de la consulta?
  fuzzyMatch(text, query) {
    var t = this.norm(text);
    var tokens = this.norm(query).split(/\s+/).filter(Boolean);
    if (!tokens.length) return true;
    var words = t.split(/[^a-z0-9]+/).filter(Boolean);
    var self = this;
    return tokens.every(function(tok) {
      if (t.indexOf(tok) !== -1) return true;
      if (tok.length < 4) return false;
      var max = tok.length >= 7 ? 2 : 1;
      return words.some(function(w) {
        return self.editDist(tok, w, max) <= max;
      });
    });
  },

  /* Catálogo local (cacheado) — usado por búsqueda difusa y cross-sell */
  async ensureCatalog() {
    if (this._catalog) return this._catalog;
    try {
      const res = await fetch('/products.json?limit=250');
      const data = await res.json();
      this._catalog = (data.products || []).map(function(p) {
        const v = (p.variants || []).find(function(x) { return x.available; }) || (p.variants || [])[0];
        return {
          handle: p.handle,
          url: '/products/' + p.handle,
          title: p.title,
          vendor: p.vendor || '',
          price: v ? parseFloat(v.price) : null,
          variantId: v ? v.id : null,
          available: v ? v.available !== false : false,
          img: p.images && p.images[0] ? p.images[0].src : null
        };
      });
    } catch(e) { this._catalog = []; }
    return this._catalog;
  },

  /* Búsqueda local tolerante cuando la API no encuentra nada */
  async localSearch(q) {
    await this.ensureCatalog();
    const self = this;
    return (this._catalog || []).filter(function(p) {
      return self.fuzzyMatch(p.title + ' ' + p.vendor, q);
    }).slice(0, 6);
  },

  /* Duplas curadas: qué sugerir según lo que ya está en el carrito (handle → [[handle, razón], ...]) */
  _pairs: {
    'melena-de-leon-60-capsulas': [['l-teanina-60-capsulas', '🧠 Más enfoque juntos'], ['l-treonato-magnesio-60-capsulas', '🎓 Memoria y concentración']],
    'melena-de-leon-gomitas-60-unidades': [['l-teanina-60-capsulas', '🧠 Más enfoque juntos']],
    'concentrado-melena-de-leon-30ml': [['l-teanina-60-capsulas', '🧠 Más enfoque juntos']],
    'concentrado-ash-melena-30ml': [['l-teanina-60-capsulas', '🧘 Calma con foco'], ['magnesio-bisglicinato-60-capsulas', '😌 Manejo del estrés']],
    'magnesio-bisglicinato-60-capsulas': [['dreams-gomitas-60-unidades', '😴 Mejor descanso'], ['l-teanina-60-capsulas', '😌 Relajo sin somnolencia']],
    'dreams-gomitas-60-unidades': [['magnesio-bisglicinato-60-capsulas', '😴 Descanso más profundo']],
    'berberina-60-capsulas': [['curcuma-pimienta', '🔥 Apoyo metabólico e inflamación'], ['citrato-magnesio-60-capsulas', '⚖️ Bienestar metabólico']],
    'curcuma-pimienta': [['berberina-60-capsulas', '🔥 Apoyo metabólico'], ['triple-magnesio-60-capsulas', '💪 Antiinflamatorio + músculos']],
    'creatina-monohidratada-300g': [['triple-magnesio-60-capsulas', '💪 Recuperación muscular'], ['concentrado-ash-melena-30ml', '⚡ Energía natural']],
    'triple-magnesio-60-capsulas': [['creatina-monohidratada-300g', '💪 Rendimiento y recuperación'], ['curcuma-pimienta', '🔥 Apoyo antiinflamatorio']],
    'l-teanina-60-capsulas': [['melena-de-leon-60-capsulas', '🧠 Enfoque sostenido']],
    'l-treonato-magnesio-60-capsulas': [['melena-de-leon-60-capsulas', '🎓 Dupla de memoria']],
    'citrato-magnesio-60-capsulas': [['berberina-60-capsulas', '⚖️ Bienestar metabólico']],
    'citrato-mag-potasio-60-capsulas': [['creatina-monohidratada-300g', '💪 Rendimiento deportivo']],
    'hair-nails-skin-gomitas-60-unidades': [['triple-magnesio-60-capsulas', '🌸 Bienestar integral']],
    'multivitaminas-probioticos-gomitas-60-unidades': [['triple-magnesio-60-capsulas', '🌿 Salud integral']]
  },

  /* CROSS-SELL en el drawer: primero duplas curadas, luego relleno del catálogo */
  async renderUpsell(cart) {
    const box = document.getElementById('cart-upsell');
    const wrap = document.getElementById('cart-upsell-items');
    if (!box || !wrap) return;
    const items = cart.items || [];
    if (!items.length) { box.style.display = 'none'; return; }
    await this.ensureCatalog();

    const byHandle = {};
    (this._catalog || []).forEach(function(p) { byHandle[p.handle] = p; });
    const inCart = items.map(function(i) { return i.handle; });
    const picks = [];
    const used = {};

    // 1) Sugerencias curadas según lo que hay en el carrito
    for (var i = 0; i < items.length && picks.length < 2; i++) {
      const pairs = this._pairs[items[i].handle] || [];
      for (var j = 0; j < pairs.length && picks.length < 2; j++) {
        const h = pairs[j][0];
        if (inCart.indexOf(h) !== -1 || used[h]) continue;
        const p = byHandle[h];
        if (p && p.available && p.variantId) {
          picks.push({ p: p, why: pairs[j][1] });
          used[h] = 1;
        }
      }
    }

    // 2) Relleno genérico si faltan cupos
    for (var k = 0; k < (this._catalog || []).length && picks.length < 2; k++) {
      const g = this._catalog[k];
      if (!g.available || !g.variantId) continue;
      if (inCart.indexOf(g.handle) !== -1 || used[g.handle]) continue;
      picks.push({ p: g, why: '' });
      used[g.handle] = 1;
    }

    if (!picks.length) { box.style.display = 'none'; return; }

    wrap.innerHTML = picks.map(function(x) {
      var p = x.p;
      var img = p.img
        ? '<img src="' + p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=80" alt="' + p.title + '" loading="lazy">'
        : '<span style="font-size:1.4rem">🌿</span>';
      var whyHtml = x.why ? '<span class="cart-upsell__why">' + x.why + '</span>' : '';
      return '<div class="cart-upsell__item"><a href="' + p.url + '" class="cart-upsell__img">' + img + '</a><div class="cart-upsell__info"><a href="' + p.url + '" class="cart-upsell__name">' + p.title + '</a>' + whyHtml + '<span class="cart-upsell__price">' + FV.fmt(p.price) + '</span></div><button type="button" class="cart-upsell__add" data-add-to-cart data-variant-id="' + p.variantId + '" aria-label="Agregar ' + p.title + '">+</button></div>';
    }).join('');
    box.style.display = 'block';
  },

  /* TOAST — aviso breve no intrusivo (ej. sin stock) */
  toast(msg) {
    const t = document.createElement('div');
    t.className = 'fv-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(() => t.classList.add('show'));
    setTimeout(() => {
      t.classList.remove('show');
      setTimeout(() => t.remove(), 350);
    }, 3200);
  },

  /* PACK — agrega varios productos al carrito en una sola llamada */
  async addPack(variantIds, btn) {
    if (btn) btn.classList.add('loading');
    try {
      const items = variantIds.map(id => ({ id: parseInt(id), quantity: 1 }));
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (res.ok) {
        await this.syncCart();
        if (btn) {
          btn.classList.remove('loading');
          btn.classList.add('added');
          setTimeout(() => btn.classList.remove('added'), 2000);
        }
        this.openCart();
      } else {
        const err = await res.json().catch(() => ({}));
        console.error('addPack error:', err.description || res.status);
        this.toast(err.description || 'No pudimos agregar el pack: revisa el stock disponible.');
        if (btn) btn.classList.remove('loading');
      }
    } catch(e) {
      console.error('addPack error:', e);
      if (btn) btn.classList.remove('loading');
    }
  },

  /* Alias de compatibilidad */
  addToCartReal(variantId, qty) { return this.addToCart(variantId, qty); },
  updateCart() { return this.syncCart(); },

  /* VACIAR CARRITO */
  async clearCart(btn) {
    if (btn) btn.textContent = 'Vaciando...';
    try {
      await fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } });
      await this.syncCart();
      this.toast('Carrito vacío');
    } catch(e) {
      console.error('clearCart error:', e);
      this.toast('No pudimos vaciar el carrito, intenta de nuevo.');
    }
    if (btn) btn.textContent = 'Vaciar carrito';
  },

  async updateQtyReal(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await this.syncCart();
    } catch(e) { console.error('updateQtyReal error:', e); }
  },

  async syncCart() {
    const cart = await this.fetchCart() || { items: [], item_count: 0, total_price: 0 };

    const body    = document.getElementById('cart-items');
    const totalEl = document.getElementById('cart-total');
    const countEls = document.querySelectorAll('.cart-count');
    const fillEl  = document.querySelector('.shipping-bar__fill');
    const msgEl   = document.querySelector('.shipping-bar__msg');

    const count   = cart.item_count;
    const total   = cart.total_price / 100;
    const threshold = 35000;

    countEls.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });

    if (fillEl) fillEl.style.width = Math.min((total / threshold) * 100, 100) + '%';
    if (msgEl) {
      if (total >= threshold && count > 0) {
        msgEl.textContent = '🎉 ¡Envío gratis en Santiago desbloqueado!';
        msgEl.style.color = 'var(--g2)';
        this.maybeCelebrateFreeShipping(msgEl);
      } else {
        msgEl.textContent = 'Te faltan ' + this.fmt(threshold - total) + ' para envío gratis en Santiago';
        msgEl.style.color = '';
        // Si baja del umbral, se rearma la celebración para la próxima vez
        try { sessionStorage.removeItem('fv_fs_celebrated'); } catch(e) {}
      }
    }
    if (totalEl) totalEl.textContent = this.fmt(total);

    // El botón de vaciar solo tiene sentido con productos dentro
    const clearBtn = document.getElementById('cart-clear');
    if (clearBtn) clearBtn.style.display = count > 0 ? '' : 'none';

    if (!body) return;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-empty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg><p>Tu carrito está vacío</p><a href="/collections/all" class="btn btn--green btn--sm" onclick="FV.closeCart()">Ver productos</a></div>';
      return;
    }

    // Conservar la posición de scroll al re-renderizar (evita el salto al cambiar cantidad)
    const scrollBox = document.querySelector('.cart-drawer__scroll');
    const keepScroll = scrollBox ? scrollBox.scrollTop : 0;

    body.innerHTML = (cart.items || []).map(function(item) {
      var imgHtml = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url + '&width=80" alt="' + item.product_title + '" style="width:100%;height:100%;object-fit:cover;border-radius:var(--r);">'
        : '<span style="font-size:1.6rem">🌿</span>';
      var linePrice = (item.final_line_price / 100);
      return '<div class="cart-item"><div class="cart-item__img">' + imgHtml + '</div><div class="cart-item__info"><p class="cart-item__brand">' + (item.vendor || '') + '</p><p class="cart-item__name">' + item.product_title + '</p><div class="cart-item__bottom"><span class="cart-item__price">' + FV.fmt(linePrice) + '</span><div class="cart-item__qty"><button class="cart-qty-btn" onclick="FV.updateQtyReal(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button><span class="cart-item__qty-num">' + item.quantity + '</span><button class="cart-qty-btn" onclick="FV.updateQtyReal(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button></div></div></div></div>';
    }).join('');

    if (scrollBox && keepScroll) scrollBox.scrollTop = keepScroll;

    // Cross-sell (no bloquea el render del carrito)
    this.renderUpsell(cart).catch(function() {});
  },

  /* CELEBRACIÓN ENVÍO GRATIS — confetti sutil con monedas al cruzar el umbral */
  maybeCelebrateFreeShipping(msgEl) {
    var seen = null;
    try { seen = sessionStorage.getItem('fv_fs_celebrated'); } catch(e) {}
    if (seen) return;
    try { sessionStorage.setItem('fv_fs_celebrated', '1'); } catch(e) {}

    msgEl.classList.add('shipping-bar__msg--unlocked');
    setTimeout(function() { msgEl.classList.remove('shipping-bar__msg--unlocked'); }, 900);

    var bar = msgEl.closest('.shipping-bar');
    if (!bar || bar.querySelector('.fs-confetti')) return;
    var wrap = document.createElement('div');
    wrap.className = 'fs-confetti';
    var colors = ['#6E8F4D', '#F4B6A6', '#2F4D3A'];
    for (var i = 0; i < 18; i++) {
      var p = document.createElement('span');
      var isCoin = i % 4 === 3;
      if (isCoin) p.className = 'fs-coin';
      p.style.left = (4 + Math.random() * 92) + '%';
      p.style.background = isCoin ? '#D7B77A' : colors[i % 3];
      p.style.animationDelay = (Math.random() * 0.5) + 's';
      p.style.animationDuration = (1.1 + Math.random() * 0.7) + 's';
      wrap.appendChild(p);
    }
    bar.appendChild(wrap);
    setTimeout(function() { wrap.remove(); }, 2600);
  },

  /* SCROLL REVEAL */
  initReveal() {
    const els = document.querySelectorAll('[data-reveal],[data-animate]');
    if (!els.length) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('revealed', 'animated');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(el => obs.observe(el));
  },

  /* SHOP FILTERS */
  initShopFilters() {
    document.querySelectorAll('.filter-tag input').forEach(cb => {
      cb.addEventListener('change', () => {
        document.querySelectorAll('.product-card').forEach(card => {
          card.style.display = 'block';
        });
      });
    });
  },

  /* NEWSLETTER — envío real al form 'customer' de Shopify vía AJAX */
  initNewsletterForms() {
    const self = this;
    document.querySelectorAll('form.fv-newsletter').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const email = form.querySelector('input[type=email]');
        if (!email || !email.value) return;
        const btn = form.querySelector('button[type=submit]');
        if (btn) { btn.classList.add('loading'); btn.disabled = true; }
        try {
          const res = await fetch(form.getAttribute('action') || '/contact', {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'text/html' }
          });
          // Si Shopify pide captcha, hacemos el envío nativo para que el usuario lo resuelva
          if (res.url && res.url.indexOf('/challenge') !== -1) { form.submit(); return; }
          if (!res.ok) throw new Error('HTTP ' + res.status);
          self.showNewsletterOk(form);
        } catch (err) {
          console.error('Newsletter error:', err);
          form.submit(); // fallback: envío nativo con recarga
        }
      });
    });
  },

  showNewsletterOk(form) {
    const sel = form.dataset.success;
    const target = sel ? document.querySelector(sel) : null;
    if (target) {
      form.style.display = 'none';
      target.classList.add('show');
      if (form.id === 'popup-form') {
        const noThanks = document.querySelector('.popup__no-thanks');
        if (noThanks) noThanks.style.display = 'none';
        setTimeout(() => this.closePopup(), 2800);
      }
    } else {
      form.innerHTML = '<p class="fv-newsletter__ok">🎉 <strong>¡Gracias!</strong> Revisa tu correo, tu descuento va en camino.</p>';
    }
  },

  /* POPUP */
  initPopup() {
    document.querySelector('.popup__close')?.addEventListener('click', () => this.closePopup());
    document.querySelector('.popup__no-thanks')?.addEventListener('click', () => this.closePopup());
    document.getElementById('popup-overlay')?.addEventListener('click', (e) => {
      if (e.target === document.getElementById('popup-overlay')) this.closePopup();
    });
  },

  openPopup() {
    const p = document.getElementById('popup-overlay');
    if (p) { p.classList.add('show'); document.body.style.overflow = 'hidden'; }
  },

  closePopup() {
    const p = document.getElementById('popup-overlay');
    if (p) { p.classList.remove('show'); document.body.style.overflow = ''; }
  },

  /* BLOG YT */
  initBlogYT() {
    document.querySelectorAll('[data-yt-id]').forEach(el => {
      el.addEventListener('click', () => {
        const id = el.dataset.ytId;
        if (!id) return;
        el.innerHTML = '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + id + '?autoplay=1" frameborder="0" allow="autoplay;encrypted-media" allowfullscreen></iframe>';
      });
    });
  },

  /* BUSCADOR PREDICTIVO — multi-instancia (desktop, header móvil, menú móvil) */
  initPredictiveSearch() {
    var self = this;
    document.querySelectorAll('.psearch').forEach(function(box) { self.initPsearchBox(box); });

    // Cerrar cualquier dropdown abierto al hacer clic fuera
    document.addEventListener('click', function(e) {
      document.querySelectorAll('.psearch__dropdown.open').forEach(function(d) {
        var box = d.closest('.psearch');
        if (box && !box.contains(e.target)) d.classList.remove('open');
      });
    });
  },

  initPsearchBox(box) {
    const input   = box.querySelector('.psearch__input');
    const results = box.querySelector('.psearch__dropdown');
    const clear   = box.querySelector('.psearch__clear');
    if (!input || !results) return;

    var timer = null;
    var self  = this;

    // Normaliza resultados (API o catálogo local) a un formato común y los pinta
    var renderList = function(list, q) {
      var html = '<div class="psearch__section-title">Productos</div>';
      list.forEach(function(p) {
        var imgSrc = p.img ? p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=80' : null;
        var imgHtml = imgSrc ? '<img src="' + imgSrc + '" alt="' + p.title + '" loading="lazy">' : '<span>🌿</span>';
        var price = p.price ? self.fmt(p.price) : '';
        html += '<a href="' + p.url + '" class="psearch__item"><div class="psearch__item-img">' + imgHtml + '</div><div class="psearch__item-info"><div class="psearch__item-vendor">' + (p.vendor || '') + '</div><div class="psearch__item-title">' + p.title + '</div>' + (price ? '<div class="psearch__item-price">' + price + '</div>' : '') + '</div><button type="button" class="psearch__item-atc" data-product-url="' + p.url.split('?')[0] + '" aria-label="Agregar al carrito"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1.6"/><circle cx="19" cy="21" r="1.6"/><path d="M1 2h3.5l2.55 12.4a2 2 0 0 0 2 1.6h8.7a2 2 0 0 0 2-1.6L22 7H5.3"/></svg></button></a>';
      });
      html += '<a href="/search?type=product&q=' + encodeURIComponent(q) + '" class="psearch__view-all">Ver todos los resultados →</a>';
      results.innerHTML = html;
    };

    var search = async function(q) {
      if (!q || q.length < 2) { results.classList.remove('open'); return; }
      results.classList.add('open');
      results.innerHTML = '<div class="psearch__loading"><div class="psearch__spinner"></div></div>';
      try {
        var res  = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6');
        var data = await res.json();
        var apiProducts = (data.resources && data.resources.results && data.resources.results.products) || [];

        var list = apiProducts.map(function(p) {
          return {
            url: p.url,
            title: p.title,
            vendor: p.vendor || '',
            // suggest.json entrega el precio en unidades de moneda (no centavos)
            price: p.price ? parseFloat(p.price) : null,
            img: p.featured_image && p.featured_image.url ? p.featured_image.url : null
          };
        });

        // Si la API no encontró nada, búsqueda local tolerante a tildes y tipeos
        if (!list.length) list = await self.localSearch(q);

        if (!list.length) {
          results.innerHTML = '<p class="psearch__no-results">No encontramos "' + q + '". <a href="/collections/all" style="color:var(--g)">Ver todo</a></p>';
          return;
        }

        renderList(list, q);

        // ATC en resultados: busca la primera variante disponible del producto y la agrega
        results.querySelectorAll('.psearch__item-atc').forEach(function(b) {
          b.addEventListener('click', async function(e) {
            e.preventDefault();
            e.stopPropagation();
            var btn = this;
            btn.classList.add('loading');
            try {
              var r = await fetch(btn.dataset.productUrl + '.js');
              var prod = await r.json();
              var variant = (prod.variants || []).find(function(v) { return v.available; }) || (prod.variants || [])[0];
              if (variant) {
                await self.addToCart(variant.id, 1, btn);
                results.classList.remove('open');
              } else {
                btn.classList.remove('loading');
              }
            } catch(err) {
              console.error('psearch ATC error:', err);
              btn.classList.remove('loading');
            }
          });
        });
      } catch(e) {
        results.innerHTML = '<p class="psearch__no-results">Error al buscar. Intenta de nuevo.</p>';
      }
    };

    input.addEventListener('input', function(e) {
      var v = e.target.value.trim();
      if (clear) clear.classList.toggle('visible', v.length > 0);
      clearTimeout(timer);
      if (!v) { results.classList.remove('open'); return; }
      timer = setTimeout(function() { search(v); }, 250);
    });

    if (clear) {
      clear.addEventListener('click', function() {
        input.value = '';
        clear.classList.remove('visible');
        results.classList.remove('open');
        input.focus();
      });
    }

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { results.classList.remove('open'); input.blur(); }
    });
  }

};

/* Puentes globales — usados por onclick inline en secciones Liquid */
function pcAddToCart(btn, id) { FV.addToCart(id, 1, btn); }

document.addEventListener('DOMContentLoaded', () => FV.init());

// Megamenu positioning — centrado bajo su trigger.
// El menú es position:absolute dentro de .header__inner (top:100%),
// así queda pegado al borde inferior del header sin cálculos de altura.
(function(){
  var inner = document.querySelector('.header__inner');
  document.querySelectorAll('.nav-item--mega').forEach(function(item){
    var menu = item.querySelector('.mega-menu');
    if(!menu) return;
    item.addEventListener('mouseenter', function(){
      if(!inner) return;
      var rect = item.getBoundingClientRect();
      var innerRect = inner.getBoundingClientRect();
      var menuW = menu.offsetWidth || 420;
      var left = rect.left + rect.width/2 - menuW/2;
      // Mantener dentro del viewport
      left = Math.max(16, Math.min(left, window.innerWidth - menuW - 16));
      menu.style.left = (left - innerRect.left) + 'px';
    });
  });
})();
